import React, { Component } from "react";

import ProductVariant from "./ProductVariant";

class ProductVariants extends Component {
	render() {
		let variants = this.props.product.variants ? this.props.product.variants : [];

		return (
			<div className="product_options_container">
				{variants.map((variant, i) => {
					return (
						<ProductVariant key={i} variant={variant} product={this.props.product} />
					);
				})}
			</div>
		);
	}
}

export default ProductVariants;



// WEBPACK FOOTER //
// ./src/components/product/variants/ProductVariants.js